var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8073 5.75002L4.2088 16.7656C4.07275 17.0012 4.00077 17.2683 4.00001 17.5404C3.99924 17.8125 4.06973 18.08 4.20446 18.3163C4.33918 18.5527 4.53344 18.7496 4.76792 18.8876C5.0024 19.0256 5.26891 19.0998 5.54095 19.1027H18.7379C19.0099 19.0998 19.2764 19.0256 19.5109 18.8876C19.7454 18.7496 19.9397 18.5527 20.0744 18.3163C20.2091 18.08 20.2796 17.8125 20.2788 17.5404C20.2781 17.2683 20.2061 17.0012 20.07 16.7656L13.4716 5.75002C13.3327 5.52106 13.1371 5.33176 12.9038 5.20039C12.6705 5.06902 12.4072 5 12.1394 5C11.8716 5 11.6084 5.06902 11.375 5.20039C11.1417 5.33176 10.9461 5.52106 10.8073 5.75002V5.75002Z",
    stroke: "#7B7986",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1394 9.75391V12.8701",
    stroke: "#7B7986",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1394 15.9863H12.1472",
    stroke: "#7B7986",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.e52b527e21b42e6aad163177144aa239.svg";
export { ForwardRef as ReactComponent };